<style>
    .ag-theme-material .ag-cell {
        line-height: 35px !important;
    }
</style>

<template>
    <div id="ag-grid-demo">
        <vx-card>
            <div class="flex flex-wrap justify-between items-center">
                <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                    <h4 style="margin-left: 10px">Assets</h4>
                </div>
                <div
                    class="flex flex-wrap items-center justify-between ag-grid-table-actions-right"
                >
                    <vs-button
                        @click="refreshData"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="refresh"
                    >Refresh</vs-button>
                    <vs-button
                        @click="showAddForm = true; form = {asset_id: '', batch: '', pack_id: ''}"
                        class="btn mb-4 md:mb-0 mr-1"
                        icon="add"
                    >Add</vs-button>
                    <vs-button
                        @click="viewData"
                        class="mb-4 md:mb-0 mr-1"
                        icon="remove_red_eye"
                        :disabled="selectedId ? false : true"
                    >View</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="removeData"
                        icon="delete"
                        :disabled="selectedId ? false : true"
                    >Delete</vs-button>
                    <vs-button
                        class="mb-4 md:mb-0 mr-1"
                        @click="showFilterForm = true"
                        icon="filter_list"
                    >Filter</vs-button>
                    <vs-dropdown>
                        <vs-button class="btn-drop" icon="expand_more">Spreadsheets</vs-button>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="getTemplate">Template</vs-dropdown-item>
                            <vs-dropdown-item @click="$refs.file.click()">Upload</vs-dropdown-item>
                            <input
                                type="file"
                                ref="file"
                                style="display: none"
                                v-on:change="uploadExcel"
                            />
                            <!-- <vs-dropdown-item @click="exportExcel">Export</vs-dropdown-item> -->
                            <vs-dropdown-item @click="exportExcel({ endpoint: 'master/assets/report/exportexcel', name: 'assets', filter: filter })">Export</vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <ag-grid-vue
                :gridOptions="gridOptions"
                class="ag-theme-material w-100 my-4 ag-grid-table"
                :columnDefs="columnDefs"
                :defaultColDef="defaultColDef"
                :rowData="data"
                colResizeDefault="shift"
                :animateRows="false"
                :floatingFilter="false"
                rowSelection="single"
                @selection-changed="onSelectionChanged"
                @rowDoubleClicked="viewData"
            ></ag-grid-vue>
            <p class="text-right">
                <b>Showing {{ dataFrom }} to {{ dataTo }} of {{ dataTotal }} total entries</b>
            </p>
            <vs-pagination :total="totalPage" v-model="currentPage" :max="7"></vs-pagination>

            <!-- Form filter data -->
            <vs-prompt buttons-hidden title="Filter" :active.sync="showFilterForm">
                <div class="con-exemple-prompt">
                    <vs-input v-model="filter.asset_id" class="mb-2 w-full" label="Asset ID" />
                    <vs-input v-model="filter.batch" class="mb-2 w-full" label="Batch" />
                    <vs-input v-model="filter.pack_id" class="mb-2 w-full" label="Pack ID" />
                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                        <vs-button color="primary" class="mt-2" @click="filterData">Search</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <!-- Form view data -->
            <vs-prompt buttons-hidden title="View" :active.sync="showViewForm">
                <div class="con-exemple-prompt">
                    <vs-input
                        v-model="form.asset_id"
                        class="mb-2 w-full"
                        label="Asset ID"
                        :disabled="!editMode"
                    />
                    <vs-input
                        v-model="form.batch"
                        class="mb-2 w-full"
                        label="Batch"
                        :disabled="!editMode"
                    />
                    <vs-input
                        v-model="form.pack_id"
                        class="mb-2 w-full"
                        label="Pack ID"
                        :disabled="!editMode"
                    />
                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                        <vs-button color="primary" class="mt-2 mr-2" @click="editMode = true">Edit</vs-button>
                        <vs-button
                            color="primary"
                            class="mt-2"
                            @click="saveData"
                            :disabled="!editMode"
                        >Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>

            <!-- Form add data -->
            <vs-prompt buttons-hidden title="Add" :active.sync="showAddForm">
                <div class="con-exemple-prompt">
                    <vs-input v-model="form.asset_id" class="mb-2 w-full" label="Asset ID" />
                    <vs-input v-model="form.batch" class="mb-2 w-full" label="Batch" />
                    <vs-input v-model="form.pack_id" class="mb-2 w-full" label="Pack ID" />
                    <vs-row vs-align="flex-start" vs-type="flex" vs-justify="flex-end" vs-w="12">
                        <vs-button color="primary" class="mt-2" @click="addData">Save</vs-button>
                    </vs-row>
                </div>
            </vs-prompt>
        </vx-card>
    </div>
</template>
<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import { saveAs } from "file-saver";
import vSelect from "vue-select";

export default {
    components: {
        vSelect,
        AgGridVue
    },
    data() {
        return {
            gridOptions: {},
            gridApi: null,
            data: [],
            columnDefs: null,
            defaultColDef: {
                sortable: true,
                editable: false,
                resizable: true,
                suppressMenu: true
            },
            selectedId: null,
            isLoading: false,
            editMode: false,
            filter: {
                asset_id: "",
                batch: "",
                pack_id: ""
            },
            form: {
                asset_id: "",
                batch: "",
                pack_id: ""
            },

            // Show forms
            showFilterForm: false,
            showViewForm: false,
            showAddForm: false,

            // Pagination
            totalPage: 0,
            currentPage: 1,
            dataFrom: 0,
            dataTo: 0,
            dataTotal: 0
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        },
        currentPage: function() {
            this.fetchData();
        }
    },
    methods: {
        onSelectionChanged() {
            var selectedRows = this.gridApi.getSelectedRows();
            var selectedRowsString = "";
            selectedRows.forEach(function(selectedRow, index) {
                if (index !== 0) {
                    selectedRowsString += ", ";
                }
                selectedRowsString += selectedRow.id;
            });
            this.selectedId = selectedRowsString;
        },
        saveData() {
            this.isLoading = true;
            this.$http
                .put("master/assets/" + this.selectedId + "/update", this.form)
                .then(() => {
                    this.isLoading = false;
                    this.form = {
                        asset_id: "",
                        batch: "",
                        pack_id: ""
                    };
                    this.editMode = false;
                    this.showViewForm = false;
                    this.selectedId = null;
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        addData() {
            this.isLoading = true;
            this.$http
                .post("master/assets/store", this.form)
                .then(() => {
                    this.isLoading = false;
                    this.showAddForm = false;
                    this.fetchData();
                })
                .catch(error => this.handleError(error))
                .then(() => (this.isLoading = false));
        },
        removeData() {
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: "Confirm",
                text: "Are you sure want to delete this data?",
                accept: () => {
                    this.isLoading = true;
                    this.$http
                        .delete("master/assets/" + this.selectedId + "/destroy")
                        .then(res => {
                            this.$vs.notify({
                                color: "success",
                                title: "Data deleted",
                                iconPack: "feather",
                                icon: "icon-check",
                                text:
                                    "The selected data was successfully deleted"
                            });
                            this.selectedId = null;
                            this.fetchData();
                        })
                        .catch(error => this.handleError(error))
                        .then(() => (this.isLoading = false));
                }
            });
        },
        refreshData() {
            this.currentPage == 1 ? this.fetchData() : (this.currentPage = 1);
        },
        fetchData() {
            this.isLoading = true;
            this.$http
                .post("master/assets?page=" + this.currentPage, this.filter)
                .then(resp => {
                    this.data = resp.data.data;
                    this.totalPage = resp.data.last_page;
                    this.currentPage = this.currentPage;
                    this.dataTotal = resp.data.total;
                    this.dataFrom = resp.data.from;
                    this.dataTo = resp.data.to;
                })
                .catch(() => {
                    this.$vs.dialog({
                        type: "confirm",
                        color: "danger",
                        title: "Error",
                        text: "Try again?",
                        accept: () => {
                            this.refreshData();
                        },
                        acceptText: "Yes",
                        cancelText: "No"
                    });
                })
                .then(() => (this.isLoading = false));
        },
        viewData() {
            this.isLoading = true;
            this.$http
                .get("master/assets/" + this.selectedId)
                .then(res => {
                    this.editMode = false
                    this.form = res.data;
                    this.showViewForm = true;
                })
                .catch()
                .then(() => (this.isLoading = false));
        },
        filterData() {
            this.currentPage = 1;
            this.showFilterForm = false;
            this.fetchData();
        },
        getTemplate() {
            this.isLoading = true;
            this.$http
                .get("master/assets/report/gettemplate", {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "Assets-template.xlsx");
                });
        },
        uploadExcel(e) {
            let file = e.target.files[0];
            let form = new FormData();
            form.append("file", file);
            this.isLoading = true;
            this.$http
                .post("/master/assets/report/importexcel", form, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    }
                })
                .then(resp => {
                    this.isLoading = false;
                    this.fetchData();
                    this.$vs.notify({
                        color: "success",
                        title: "Upload Success",
                        text: "Upload success."
                    });
                })
                .catch(error => this.handleError(error));
        },
        exportExcel() {
            this.isLoading = true;
            this.$http
                .post("master/assets/report/exportexcel", this.filter, {
                    responseType: "blob"
                })
                .then(response => {
                    this.isLoading = false;
                    saveAs(response.data, "Assets-list-export.xlsx");
                });
        }
    },
    mounted() {
        this.fetchData();
        this.gridApi = this.gridOptions.api;
    },
    beforeMount() {
        this.columnDefs = [
            {
                headerName: "Asset ID",
                field: "asset_id",
                width: 120,
            },
            {
                headerName: "Batch",
                field: "batch",
                width: 120
            },
            {
                headerName: "Pack ID",
                field: "pack_id",
                width: 120
            }
        ];
        this.gridOptions.getRowHeight = function(params) {
            return 35;
        }
    }
};
</script>

